export default __webpack_public_path__ + "static/media/banner-verificar.41ffea17.png";